import { FT } from 'ft'
import { Sprite, Text, TextStyle } from 'pixi.js'

export const heros = ['yi', 'md', 'neeko', 'akl', 'ls', 'slk']

const $select = 'hero-select'
const $unselect = 'hero-unselect'

FT.rm.addImage($select)
FT.rm.addImage($unselect)

heros.forEach(hero => {
  FT.rm.addImage(`avatar-${hero}`)
})

const selectStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 36,
  fill: '#b55900',
  stroke: '#ffffff',
  strokeThickness: 5,
})

const unselectStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 36,
  fill: '#1f2c6a',

  stroke: '#ffffff',
  strokeThickness: 5,
})

const chineseNames = {
  yi: '持胡萝卜的雪人 易',
  md: '冰封王子 蒙多',
  neeko: '冬境仙灵 妮蔻',
  akl: 'K/DA阿卡丽 至臻',
  ls: '狂心冰王 图奇',
  slk: '冬境仙灵 索拉卡',
}

class Hero extends Sprite {
  #border
  #text

  constructor(name) {
    super()
    this.texture = FT.rm.texture(`avatar-${name}`)
    this.name = name
    this.interactive = true
    this.anchor.set(0.5)
    this.scale.set(0.8)

    const border = new Sprite()
    this.#border = border
    border.texture = FT.rm.texture($unselect)
    border.anchor.set(0.5)
    border.y = 10
    this.addChild(border)

    const text = new Text(chineseNames[name], unselectStyle)
    this.#text = text
    text.anchor.set(0.5)
    text.y = 100
    this.addChild(text)
  }

  select() {
    this.#border.texture = FT.rm.texture($select)
    this.#text.style = selectStyle
  }

  unselect() {
    this.#border.texture = FT.rm.texture($unselect)
    this.#text.style = unselectStyle
  }
}

export default Hero
